import React from "react";
import "../styles/loginStyle/Login.css";
import MudarSenhaForm from "../components/mudarSenha/mudarSenhaForm";

export default function MudarSenha() {
  return (
    <div className="login-wrapper">
      {/* Fundo branco com mapa */}
      <img src="/background-cidade.svg" alt="background" className="login-bg" />

      {/* Conteúdo principal */}
      <div className="login-container">
        <div className="login-left">
          <img src="/logotact.svg" alt="Logo" className="login-logo" />
          <p className="login-title">Redefinir Senha</p>
          <p className="login-text">
            Digite sua nova senha e confirme para concluir a redefinição.
          </p>
          <MudarSenhaForm />
        </div>

        <div className="login-right">
          <img src="/polygono-cidade.svg" alt="Polygon" className="login-polygon" />
        </div>
      </div>
    </div>
  );
}
